<template>
	<div>
		<h1>Validation produits</h1>

		<div v-if="!products">
			Il n'y a pas de changement pour le moment et pour la recherche sélectionnée.
		</div>
		<div v-else>
			<b-select @change="set_product()" v-model="product_id" :options="products"></b-select>
		</div>

        <div>
            <br />
            <b-button v-b-toggle.collapse variant="primary">Recherche</b-button>
            <b-collapse id="collapse" class="mt-2">
                <div :id="'builder' + id"></div>
                <b-container style="margin: 0; padding: 0; max-width: none">
                    <b-row>
                        <b-col>
                            <span>Source</span>
                            <b-input list="source" v-model="search.source"></b-input>
                            <datalist id="source">
                                <option v-for="(source, idx) in sources" :key="idx" :value="source"/>
                            </datalist>
                        </b-col>
                        <b-col>
                            <span>Marque</span>
                            <b-input list="marque" v-model="search.brand"></b-input>
                            <datalist id="marque">
                                <option v-for="(brand, idx) in brands" :key="idx" :value="brand"/>
                            </datalist>
                        </b-col>
                        <b-col>
                            <span>Catégorie</span>
                            <b-input list="category" v-model="search.category"></b-input>
                            <datalist id="category">
                                <option v-for="(category, idx) in categories_name" :key="idx" :value="category"/>
                            </datalist>
                        </b-col>
                        <b-col>
                            <span>Nom</span>
                            <b-input v-model="search.name"></b-input>
                        </b-col>
                        <b-col cols="1">
                            <br />
                            <b-button @click="reset_search"><i class="fas fa-eraser"></i></b-button>
                        </b-col>
                    </b-row>
                </b-container>
                <br />
                <b-button @click="f_search">Excécuter la Recherche</b-button>
            </b-collapse>
            <br /><br />
        </div>

        <div v-show="mode == 'list' && facet == 'media'">

            <b-table striped hover :items="products_list" :fields="[
                {
                    key: 'nom_en',
                    label: 'Nom',
                    thStyle: { width: '20%' }
                },
                {
                    key: 'source',
                    label: 'Source',
                    thStyle: { width: '10%' }
                },
                {
                    key: 'marque',
                    label: 'Marque',
                    thStyle: { width: '10%' }
                },
                {
                    key: 'categories_id',
                    label: 'Catégories',
                    tdStyle: { width: '10%' }
                },
                {
                    key: 'url_image_reference',
                    label: 'Référence',
                    tdStyle: { width: '15%' }
                },
                {
                    key: 'urls_image',
                    label: 'Image',
                    thStyle: { width: '15%' }
                },
                {
                    key: 'urls_youtube',
                    label: 'Vidéo',
                    thStyle: { width: '15%' }
                },
                {
                    key: 'index',
                    label: '',
                    thStyle: { width: '5%' }
				}
            ]">
                <template v-slot:cell(source)="data">
                    <span v-b-tooltip.hover :title="data.item.ref">{{data.item.source}}</span>
                </template>
                <template v-slot:cell(url_image_reference)="data">
                    <img style="max-width: 100px" :src="data.item.url_image_reference" />
                </template>
                <template v-slot:cell(urls_image)="data">
                    <img :id="'image_' + data.item.id" style="max-width: 100px" :src="data.item.urls_image.length > 0 ? data.item.urls_image[0].url : ''" />
                    <span v-if="data.item.urls_image.length > 0">
                        <br />
                        {{data.item.urls_image[0].width}} x {{data.item.urls_image[0].height}}<br />
                        {{data.item.urls_image[0].source}}
                    </span>
                    <b-tooltip custom-class="long-tooltip" v-if="data.item.urls_image.length > 0" :target="'image_' + data.item.id" placement="top">
                        Url : {{data.item.urls_image[0].url}}<br />
                        Titre : {{data.item.urls_image[0].title}}<br />
                        Source : {{data.item.urls_image[0].source}}<br />
                        Page: {{data.item.urls_image[0].link}}<br />
                        Taille: {{data.item.urls_image[0].width}} X {{data.item.urls_image[0].height}}<br />
                        Position de la recherche: {{data.item.urls_image[0].position}}<br />
                        Score: {{data.item.urls_image[0].score}}
                    </b-tooltip>
                </template>
                <template v-slot:cell(urls_youtube)="data">
                    <img :id="'youtube_' + data.item.id" :src='(data.item.urls_youtube.length > 0 && data.item.urls_youtube[0].url) ? "https://img.youtube.com/vi/" + data.item.urls_youtube[0].url.replace(/.*\//, "").replace(/.*v=/, "").replace(/&.*/, "") + "/hqdefault.jpg" : ""' style="max-width: 150px;" />
                    <b-tooltip custom-class="long-tooltip" v-if="data.item.urls_youtube.length > 0" :target="'youtube_' + data.item.id" placement="top">
                        Url: {{ data.item.urls_youtube[0].url}}<br />
                        Titre : {{ data.item.urls_youtube[0].title}}<br />
                        Description: {{ data.item.urls_youtube[0].description}}<br />
                        Nom de la chaîne : {{ data.item.urls_youtube[0].channel_name}}<br />
                        Adresse de la chaîne: {{data.item.urls_youtube[0].channel_link}}<br />
                        Nombre de vues : {{ data.item.urls_youtube[0].views}}<br />
                        Publication: {{ data.item.urls_youtube[0].published_date}} (au {{ data.item.urls_youtube[0].get_date}})<br />
                        Durée: {{ data.item.urls_youtube[0].length}}<br />
                        Position de la recherche: {{ data.item.urls_youtube[0].position}}<br />
                        Extensions: {{  data.item.urls_youtube[0].extensions ?  data.item.urls_youtube[0].extensions.join(", ") : ""}}
                    </b-tooltip>
                </template>
                <template v-slot:cell(categories_id)="data">
                    <span v-for="category in data.item.categories_id" :key="category">
                        <b-badge variant="primary">{{categories_obj[category] ? categories_obj[category].name_fr : ""}}</b-badge><br />
                    </span>
                </template>
                <template v-slot:cell(index)="data">                
                    <b-button variant="link" @click="remove(data.index)"><i class="fas fa-times"></i></b-button>
                    <b-button @click="view_product(data.index)" variant="link"><i class="fas fa-search"></i></b-button>
                </template>
            </b-table>

            <!-- <p>
                <b-button @click="test_rules_list">Réordonner la liste des médias</b-button>
            </p> -->

            <div v-if="spinner" class="center_spinner">
                <fade-loader></fade-loader>
            </div>

            <b-button variant="success" @click="set_facet('media')">Medias</b-button>&nbsp;
            <b-button variant="primary" @click="set_facet('text')">Textes</b-button><br /><br />
            <b-button @click="send_list">Enregistrer</b-button>
            <br /><br />
            <span v-if="page > 0">
                <b-button variant="link" @click="addPage(-1)">&lt;</b-button>
            </span>
            Page {{ page + 1 }}
            <span v-if="products && ((page + 1) * 10 < products.length)">
                <b-button variant="link" @click="addPage(1)">&gt;</b-button>
            </span>
        </div>


        <div v-show="mode == 'list' && facet == 'text'">

            <b-table striped hover :items="products_list" :fields="[
                {
                    key: 'nom_en',
                    label: 'Nom',
                    thStyle: { width: '30%' }
                },
                {
                    key: 'description_courte_en',
                    label: 'Description courte',
                    thStyle: { width: '30%' }
                },
                {
                    key: 'description_en',
                    label: 'Description',
                    thStyle: { width: '30%' }
                },
                {
                    key: 'index',
                    label: '',
                    thStyle: { width: '10%' }
				}
            ]">
                <template v-slot:cell(nom_en)="data">
                    <div><country-flag country='gb' size="small"/> {{data.item.nom_en}}</div><br />
                    <div><country-flag country='fr' size="small"/> {{data.item.nom_fr}}</div><br />
                    <div><country-flag country='es' size="small"/> {{data.item.nom_es}}</div>
                </template>
                <template v-slot:cell(description_en)="data">
                    <div><country-flag country='gb' size="small"/> <span v-b-modal="'desc_en_' + data.item.id"> {{data.item.description_en.substring(0, 150)}}{{data.item.description_en.length > 150 ? "..." : ""}}</span></div><br />
                    <b-modal ok-only :id="'desc_en_' + data.item.id" title="Description en" size="xl">
                        <div v-html="data.item.description_en"></div>
                    </b-modal>
                    <div><country-flag country='fr' size="small"/> <span v-b-modal="'desc_fr_' + data.item.id"> {{data.item.description_fr.substring(0, 150)}}{{data.item.description_fr.length > 150 ? "..." : ""}}</span></div><br />
                    <b-modal ok-only :id="'desc_fr_' + data.item.id" title="Description fr" size="xl">
                        <div v-html="data.item.description_fr"></div>
                    </b-modal>
                    <div><country-flag country='es' size="small"/> <span v-b-modal="'desc_es_' + data.item.id"> {{data.item.description_es.substring(0, 150)}}{{data.item.description_es.length > 150 ? "..." : ""}}</span></div><br />
                    <b-modal ok-only :id="'desc_es_' + data.item.id" title="Description es" size="xl">
                        <div v-html="data.item.description_es"></div>
                    </b-modal>
                </template>
                <template v-slot:cell(description_courte_en)="data">
                    <div><country-flag country='gb' size="small"/> <span v-b-modal="'desc_courte_en_' + data.item.id"> {{data.item.description_courte_en.substring(0, 150)}}{{data.item.description_courte_en.length > 150 ? "..." : ""}}</span></div><br />
                    <b-modal ok-only :id="'desc_courte_en_' + data.item.id" title="Description courte en" size="xl">
                        <div v-html="data.item.description_courte_en"></div>
                    </b-modal>
                    <div><country-flag country='fr' size="small"/> <span v-b-modal="'desc_courte_fr_' + data.item.id"> {{data.item.description_courte_fr.substring(0, 150)}}{{data.item.description_courte_fr.length > 150 ? "..." : ""}}</span></div><br />
                    <b-modal ok-only :id="'desc_courte_fr_' + data.item.id" title="Description courte fr" size="xl">
                        <div v-html="data.item.description_courte_fr"></div>
                    </b-modal>
                    <div><country-flag country='es' size="small"/> <span v-b-modal="'desc_courte_es_' + data.item.id"> {{data.item.description_courte_es.substring(0, 150)}}{{data.item.description_courte_es.length > 150 ? "..." : ""}}</span></div><br />
                    <b-modal ok-only :id="'desc_courte_es_' + data.item.id" title="Description courte es" size="xl">
                        <div v-html="data.item.description_courte_es"></div>
                    </b-modal>
                </template>
                <template v-slot:cell(index)="data">                
                    <b-button variant="link" @click="remove(data.index)"><i class="fas fa-times"></i></b-button>
                    <b-button @click="view_product(data.index)" variant="link"><i class="fas fa-search"></i></b-button>
                </template>
            </b-table>

            <!-- <p>
                <b-button @click="test_rules_list">Réordonner la liste des médias</b-button>
            </p> -->

            <div v-if="spinner" class="center_spinner">
                <fade-loader></fade-loader>
            </div>

            <b-button variant="primary" @click="set_facet('media')">Medias</b-button>&nbsp;
            <b-button variant="success" @click="set_facet('text')">Textes</b-button><br /><br />
            <b-button @click="send_list">Enregistrer</b-button>
            <br /><br />
            <span v-if="page > 0">
                <b-button variant="link" @click="addPage(-1)">&lt;</b-button>
            </span>
            Page {{ page + 1 }}
            <span v-if="products && ((page + 1) * 10 < products.length)">
                <b-button variant="link" @click="addPage(1)">&gt;</b-button>
            </span>
        </div>

        <div v-show="mode == 'product'">
            <div v-if="product">

                <div v-if="products_list.some(item => item.id === product.id)">
                    <b-button @click="view_list">Retourner à la liste</b-button>
                </div>

                <p>
                    Source : {{ product.source }}
                    <br />
                    <span v-if="product.ref && product.ref.startsWith('http')">
                        Lien : <a target="_blank" :href="product.ref">{{ product.ref }}</a>
                    </span>
                    <span v-else>
                        Référence : {{ product.ref }}
                    </span>
                </p>

                <!-- <p>
                    <b-button @click="test_rules">Réordonner la liste des médias</b-button>
                </p> -->
                
                <div v-if="spinner" class="center_spinner">
                    <fade-loader></fade-loader>
                </div>

                <h3>Images <b-button variant="link" @click="test_rules(config.project_generate_image, 'image')"><i class="fas fa-sync-alt"></i></b-button></h3>

                <div>Images retenues</div>
                <draggable v-model="product.urls_image" group="image">
                    <div @click="image = element" :style="'display: inline-block; border: 1px solid ' + ((image && image.url == element.url) ? 'green' : 'black' ) +'; padding: 10px;background-color:white;height: 180px'" v-for="(element, idx) in product.urls_image" :key="idx">
                        <img :src="element.url" style="height:100px;" />
                        <div>{{element.link ? element.link.replace(/https?:\/\/(www.)?/gi, "").replace(/\/.*/, "") : element.url.replace(/https?:\/\/(www.)?/gi, "").replace(/\/.*/, "")}}</div>
                        <div>{{element.width}} X {{element.height}}</div>
                    </div>
                </draggable>
                <b-button @click="product.urls_image.push({title: '', url: config.default_url_image, source: '', link: ''}); image = product.urls_image[product.urls_image.length - 1]" variant="link"><i class="fas fa-plus"></i></b-button>

                <div>Liste d'images</div>
                <draggable v-model="product.list_urls_image" group="image">
                    <div @click="image = element" :style="'display: inline-block; border: 1px solid ' + ((image && image.url == element.url) ? 'green' : 'black' ) +'; padding: 10px;background-color:white;height: 180px'" v-for="(element, idx) in product.list_urls_image" :key="idx">
                        <img @error="imageError(idx)"  :src="element.url" style="height:100px;" />
                        <div>{{element.link ? element.link.replace(/https?:\/\/(www.)?/gi, "").replace(/\/.*/, "") : element.url.replace(/https?:\/\/(www.)?/gi, "").replace(/\/.*/, "")}}</div>
                        <div>{{element.width}} X {{element.height}}</div>
                    </div>
                </draggable>

                <b-container style="margin: 0; padding: 0; max-width: none">
                    <b-row>
                        <b-col cols="5">
                            <div>Image de référence</div>
                            <img style="max-width: 100%; max-height: 500px" :src="product.url_image_reference" />
                        </b-col>
                        <b-col cols="7">
                            <div>Image</div>

                            <div v-if="image">
                                <img style="max-width: 100%; max-height: 500px" :src="image.url" />

                                <p>
                                    Url<br />
                                    <b-input v-model="image.url" />
                                    Titre : {{image.title}}<br />
                                    Source : {{image.source}}<br />
                                    Page: <a :href="image.link" target="_blank">{{image.link}}</a><br />
                                    Taille: {{image.width}} X {{image.height}}<br />
                                    Position de la recherche: {{image.position}}<br />
                                    Score: {{image.score}}
                                </p>
                            </div>
                        </b-col>
                    </b-row>
                </b-container>

                <h3>Vidéo <b-button variant="link" @click="test_rules(config.project_generate_youtube, 'youtube')"><i class="fas fa-sync-alt"></i></b-button></h3>

                <div>Vidéos retenues</div>
                <draggable v-model="product.urls_youtube" group="youtube">
                    <div @click="youtube = element" :style="'display: inline-block; border: 1px solid ' + ((youtube && youtube.url == element.url) ? 'green' : 'black' ) +'; padding: 10px;background-color:white;height: 180px'" v-for="(element, idx) in product.urls_youtube" :key="idx">
                        <img :src='"https://img.youtube.com/vi/" + element.url.replace(/.*\//, "").replace(/.*v=/, "").replace(/&.*/, "") + "/hqdefault.jpg"' style="max-height:100px; max-width: 120px;" />
                        <div>{{element.channel_name}}</div>
                        <div>{{element.views}} vues</div>
                    </div>
                </draggable>
                <b-button @click="product.urls_youtube.push({title: '', url: '', channel_name: '', channel_link: '', description: ''}); image = product.urls_youtube[product.urls_youtube.length - 1]" variant="link"><i class="fas fa-plus"></i></b-button>

                <div>Liste de vidéos</div>
                <draggable v-model="product.list_urls_youtube" group="youtube">
                    <div @click="youtube = element" :style="'display: inline-block; border: 1px solid ' + ((youtube && youtube.url == element.url) ? 'green' : 'black' ) +'; padding: 10px;background-color:white;height: 180px'" v-for="(element, idx) in product.list_urls_youtube" :key="idx">
                        <img :src='"https://img.youtube.com/vi/" + element.url.replace(/.*\//, "").replace(/.*v=/, "").replace(/&.*/, "") + "/hqdefault.jpg"' style="max-height:100px; max-width: 120px;" />
                        <div>{{element.channel_name}}</div>
                        <div>{{element.views}} vues</div>
                    </div>
                </draggable>

                <b-container style="margin: 0; padding: 0; max-width: none">
                    <b-row>
                        <b-col cols="5">
                            <div>Image de référence</div>
                            <img style="max-width: 100%; max-height: 500px" :src="product.url_image_reference" />
                        </b-col>
                        <b-col cols="7">
                            <div>Vidéo</div>

                            <div v-if="youtube">
                                <iframe width="100%" height="480" :src="'https://www.youtube.com/embed/' + youtube.url.replace(/.*\//, '').replace(/.*v=/, '').replace(/&.*/, '')" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;" allowfullscreen></iframe>
                                <p>
                                    Url<br />
                                    <b-input v-model="youtube.url" />
                                    Titre : {{youtube.title}}<br />
                                    Description: {{youtube.description}}<br />
                                    Nom de la chaîne : {{youtube.channel_name}}<br />
                                    Adresse de la chaîne: <a :href="youtube.channel_link" target="_blank">{{youtube.channel_link}}</a><br />
                                    Nombre de vues : {{youtube.views}}<br />
                                    Publication: {{youtube.published_date}} (au {{youtube.get_date}})<br />
                                    Durée: {{youtube.length}}<br />
                                    Position de la recherche: {{youtube.position}}<br />
                                    Extensions: {{ youtube.extensions ? youtube.extensions.join(", ") : ""}}
                                </p>
                            </div>
                        </b-col>
                    </b-row>
                </b-container>

                <h3>Noms</h3>

                <b-container style="margin: 0; padding: 0; max-width: none">
                    <b-row style="margin-bottom:10px">
                        <b-col cols="1">
                            Anglais
                        </b-col>
                        <b-col>
                            <b-input v-model="product.nom_en"></b-input>
                        </b-col>
                    </b-row>
                    <b-row style="margin-bottom:10px">
                        <b-col cols="1">
                            Francais
                        </b-col>
                        <b-col>
                            <b-input v-model="product.nom_fr"></b-input>
                        </b-col>
                    </b-row>
                    <b-row style="margin-bottom:10px">
                        <b-col cols="1">
                            Espagnol
                        </b-col>
                        <b-col>
                            <b-input v-model="product.nom_es"></b-input>
                        </b-col>
                    </b-row>
                </b-container>

                <h3>Descriptions courtes</h3>

                <div>Anglais</div>
                <b-textarea v-model="product.description_courte_en"></b-textarea>
                <div>Francais</div>
                <b-textarea v-model="product.description_courte_fr"></b-textarea>
                <div>Espagnol</div>
                <b-textarea v-model="product.description_courte_es"></b-textarea>

                <h3>Description</h3>

                <b-container style="margin: 0; padding: 0; max-width: none">
                    <b-row style="margin-bottom:10px">
                        <b-col cols="6">
                            Anglais
                            <b-textarea style="height:90%;" v-model="product.description_en"></b-textarea>
                        </b-col>
                        <b-col>
                            <div v-html="product.description_en"></div>
                        </b-col>
                    </b-row>
                    <b-row style="margin-bottom:10px">
                        <b-col cols="6">
                            Francais
                            <b-textarea style="height:90%;" v-model="product.description_fr"></b-textarea>
                        </b-col>
                        <b-col>
                            <div v-html="product.description_fr"></div>
                        </b-col>
                    </b-row>
                    <b-row style="margin-bottom:10px">
                        <b-col cols="6">
                            Espagnol
                            <b-textarea style="height:90%;" v-model="product.description_es"></b-textarea>
                        </b-col>
                        <b-col>
                            <div v-html="product.description_es"></div>
                        </b-col>
                    </b-row>
                </b-container>

                <h3>Marque</h3>

                <b-input v-model="product.marque"></b-input>

                <h3>Prix</h3>

                <p>Référence
                    <b-input v-model="product.prix_reference"></b-input>
                </p>

                <p>Achat
                    <b-input v-model="product.prix_achat"></b-input>
                </p>

                <p>Vente
                    <b-input v-model="product.prix"></b-input>
                </p>

                <b-checkbox v-model="product.annonce" value="1" unchecked-value="0" >Créer une annonce</b-checkbox>

                <h3>Référence fabriquant</h3>

                <b-input v-model="product.manufacturer_code"></b-input>

                <h3>Catégories</h3>

                <p>
                    <span v-for="category in categories_product" :key="category">
                        <b-badge variant="primary">{{categories_obj[category] ? categories_obj[category].name_fr : ""}}</b-badge>&nbsp;
                    </span>
                </p>

                <Tree :edit="true" @updateNode="updateNode" id="my-tree-id" ref="tree" :custom-options="categories_options" :custom-styles="categories_styles" :nodes="categories"></Tree>

                <br />
                <p>
                    Statut de publication
                    <b-form-radio v-model="product.status_origami" name="status_origami" value="">Actif</b-form-radio>
                    <b-form-radio v-model="product.status_origami" name="status_origami" value="produit_référent">Produit référent</b-form-radio>
                    <b-form-radio v-model="product.status_origami" name="status_origami" value="waiting">En attente</b-form-radio>
                </p>

                <b-button @click="send(true)">Enregistrer</b-button>&nbsp;
                <b-button @click="send(false)">Mettre en attente</b-button>
            </div>
        </div>

	</div>
</template>

<script>
    import Tree from "../../../public/js/vuejs-tree/src/components/Tree.vue";
    import FadeLoader from "vue-spinner/src/FadeLoader.vue";
    import CountryFlag from 'vue-country-flag';
    import uniqueId from "lodash.uniqueid";
    import draggable from "vuedraggable";
    import $ from "jquery";

	import store from "../../store"   
	import utils from "../../services/utils.js";
	import users from "../../services/users.js";
    import database from "../../services/database.js";
	import treatments from "../../services/treatments.js";
	import utils_treatments from "../../utils/treatment.js";
	import edit_tabulator from "../../components/edit_tabulator.vue";

    const json2csv = require("json2csv").parse;
	var clone = require("clone");

	import "../../../public/js/query-builder.default.min.css";
	import "../../../public/js/query-builder.min.js";
	import "../../../public/js/query-builder-fr.js";
    
	export default {
		components: {
            edit_tabulator,
            FadeLoader,
            draggable,
            Tree,
            CountryFlag
		},
		data() {
			return {
                facet: "media",
				config: {},
				products: [],
				product_id: null,
				product: null,
				categories: [
                ],
                categories_obj: {},
                categories_obj_names: {},
                categories_product: [],
                image: null,
                youtube: null,
                search: {
                    source: "",
                    brand: "",
                    category: "",
                    name: ""
                },
                sources: [],
                brands: [],
                categories_name: [],
                spinner: false,
                products_list: [],
                mode: "list",
                page: 0,
                id: uniqueId(""),
                rules_sql: ""
			};
		},
        computed: {
            categories_styles() {
                return {
                    tree: {
                        height: "auto",
                        maxHeight: "300px",
                        overflowY: "visible",
                        display: "inline-block",
                        textAlign: "left",
                    },
                    row: {
                        style: {
                            width: "500px",
                            cursor: "pointer",
                        },
                        child: {
                            class: "",
                            style: {
                            height: "35px",
                            },
                            active: {
                                style: {
                                    height: "35px",
                                },
                            },
                        },
                    },
                    rowIndent: {
                        paddingLeft: "20px",
                    },
                    text: {
                        // class: "" // uncomment this line to overwrite the 'capitalize' class, or add a custom class
                        style: {},
                        active: {
                            style: {
                                "font-weight": "bold",
                                color: "#2ECC71",
                            },
                        },
                    },
                };
            },
            categories_options() {
                return {
                    treeEvents: {
                        expanded: {
                            state: false,
                        },
                        collapsed: {
                            state: false,
                        },
                        selected: {
                            state: false
                        },
                        checked: {
                            state: true,
                        },
                    },
                    events: {
                        expanded: {
                            state: true,
                        },
                        selected: {
                            state: true,
                        },
                        checked: {
                            state: true
                        },
                        editableName: {
                            state: true,
                            calledEvent: "expanded",
                        },
                    },
                    addNode: {
                        state: false,
                        fn: null,
                        appearOnHover: false,
                    },
                    editNode: { state: false, fn: null, appearOnHover: false },
                    deleteNode: {
                        state: false,
                        fn: null,
                        appearOnHover: true,
                    },
                    showTags: true,
                };
            },
        },
		methods: {
            set_facet(facet)
            {
                this.facet = facet;
                window.scrollTo(0,0);
            },
            async addPage(nb)
            {
                this.page += nb;
                this.set_list();
            },
            async imageError(idx)
            {
                this.product.list_urls_image.splice(idx, 1);
            },
            async view_list()
            {
                if (this.product)
                    this.product.categories_id = this.$refs.tree.getCheckedNodes("id", false);

                this.mode = "list";
                this.product_id = null;
            },
            async view_product(idx)
            {
                if (this.product)
                    this.product.categories_id = this.$refs.tree.getCheckedNodes("id", false);

                await this.set(this.products_list[idx]);
                this.mode = "product";

            },
            async remove(idx)
            {
                var product = this.products_list[idx];
                for (var i = 0; i < this.products.length; i++)
                {
                    if (this.products[i].value == product.id)
                    {
                        this.products.splice(i, 1);
                        break;
                    }
                }     
                this.products_list.splice(idx, 1);

                var str = json2csv([product], {
					fields: Object.keys(product),
					fieldNames: Object.keys(product),
					del: ",",
					quote: '"',
				});
				
				const bytes = new TextEncoder().encode(str);
				const blob = new Blob([bytes], {
					type: "text/plain",
				});

                var formData = new FormData();
                formData.append("data.csv", blob);
                
                var resp = await utils_treatments.test_project(
                    this.config.project_validation_hide,
                    formData,
                    false,
                    [],
                    "",
                    true,
                    [],
                    0,
                    {},
                    {},
                    []
                ) 

            },
            async test_rules_list()
            {
                this.spinner = true;

                var str = json2csv(this.products_list, {
					fields: Object.keys(this.products_list[0]),
					fieldNames: Object.keys(this.products_list[0]),
					del: ",",
					quote: '"',
				});
				
				const bytes = new TextEncoder().encode(str);
				const blob = new Blob([bytes], {
					type: "text/plain",
				});

                var formData = new FormData();
                formData.append("data.csv", blob);
                
                var resp = await utils_treatments.test_project(
                    this.config.rules,
                    formData,
                    false,
                    [],
                    "",
                    true,
                    [],
                    0,
                    {},
                    {},
                    []
                ) 

                console.log(resp)

                resp = resp.results;
                var obj = {};
                for (var i = 0; i < resp.length; i++)
                {
                    obj[resp[i].id] = resp[i];
                }

                console.log(obj)

                for (var i = 0; i < this.products_list.length; i++)
                {
                    if (obj[this.products_list[i].id])
                    {
                        this.products_list[i].list_urls_image = JSON.parse(obj[this.products_list[i].id].list_urls_image).slice(0, 10);
                        this.products_list[i].urls_image = JSON.parse(obj[this.products_list[i].id].urls_image);
                    }
                }

                this.spinner = false;
            },
            async test_rules(project_uid, type = "")
            {
                this.spinner = true;

                var str = json2csv([this.product], {
					fields: Object.keys(this.product),
					fieldNames: Object.keys(this.product),
					del: ",",
					quote: '"',
				});
				
				const bytes = new TextEncoder().encode(str);
				const blob = new Blob([bytes], {
					type: "text/plain",
				});

                var formData = new FormData();
                formData.append("data.csv", blob, "data.csv");
                
                var resp = await utils_treatments.test_project(
                    project_uid || this.config.rules,
                    formData,
                    false,
                    [],
                    "",
                    true,
                    [],
                    0,
                    {},
                    {},
                    []
                ) 

                console.log(resp)

                resp = resp.results[0];
                if (!type || type == "image")
                {
                    this.product.list_urls_image = JSON.parse(resp.list_urls_image).slice(0, 10);
                    this.product.urls_image = JSON.parse(resp.urls_image);
                }
                if (!type || type == "youtube")
                {
                    this.product.list_urls_youtube = JSON.parse(resp.list_urls_youtube).slice(0, 10);
                    this.product.urls_youtube = JSON.parse(resp.urls_youtube);
                }
                this.spinner = false;
            },
            updateNode(node)
            {
                if (node.state.checked)
                {
                    while (node.parent)
                    {
                        this.$refs.tree.checkNode(node.parent);
                        node = this.$refs.tree.findNode(node.parent);
                    }
                }

                this.categories_product = this.$refs.tree.getCheckedNodes("id", false);
            },
            async set_product()
            {
                this.mode = "product"
                this.set()
            },
            async set_list()
            {
                this.products_list = [];

                var ids = "";
                for (var i = this.page * 10; i < this.products.length && i < (this.page + 1) * 10; i++)
                {
                    if (ids)
                        ids += ","
                    ids += this.products[i].value;
                }

                if (ids == "" && this.products.length != 0 && this.page > 0)
                {
                    this.page = 0;
                    return this.set_list();
                }

                this.products_list = await database.get("select", this.config.table, {
					select: "*",
					where: "id in (" + ids + ")"
                });
                
                for (var i = 0; i < this.products_list.length; i++)
                {
                    this.products_list[i].list_urls_image = JSON.parse(this.products_list[i].list_urls_image);
                    this.products_list[i].urls_image = JSON.parse(this.products_list[i].urls_image);
                    this.products_list[i].list_urls_youtube = JSON.parse(this.products_list[i].list_urls_youtube);
                    this.products_list[i].urls_youtube = JSON.parse(this.products_list[i].urls_youtube);
                    this.products_list[i].categories_id = JSON.parse(this.products_list[i].categories_id);
                }

                if (this.products_list.length > 0)
                {
                    this.product_id = null;
                    //await this.set();
                }
            },
			async set(product = null)
			{
                console.log("set")
                var self = this;

                this.image = null;
                this.youtube = null;

                if (!product)
                {
                    product = await database.get("select", this.config.table, {
                        select: "*",
                        where: "id = '" + this.product_id + "'"
                    });
                    product = product[0];

                    try
                    {
                        product.list_urls_image = JSON.parse(product.list_urls_image);
                    }
                    catch (err)
                    {
                        product.list_urls_image = []
                    }
                    try
                    {
                        product.urls_image = JSON.parse(product.urls_image);
                    }
                    catch (err)
                    {
                        product.urls_image = [];
                    }
                    try
                    {
                        product.list_urls_youtube = JSON.parse(product.list_urls_youtube);
                    }
                    catch (err)
                    {
                        product.list_urls_youtube = [];
                    }
                    try
                    {
                        product.urls_youtube = JSON.parse(product.urls_youtube);
                    }
                    catch (err)
                    {
                        product.urls_youtube = [];
                    }
                    try
                    {
                        product.categories_id = JSON.parse(product.categories_id);
                    }
                    catch (err)
                    {
                        product.categories_id = [];
                    }
                }

                this.product_id = product.id

                this.product = product;
                this.product.list_urls_image = this.product.list_urls_image.slice(0, 10);
                this.product.list_urls_youtube = this.product.list_urls_youtube.slice(0, 10);
                
                while (!this.$refs.tree) {
					await new Promise((resolve) =>
						setTimeout(resolve, 100)
					);
				}

                this.$refs.tree.uncheckAllNodes();
                this.$refs.tree.collapseAllNodes();

                this.$refs.tree.checkNode(this.categories[0].id);

                for (var i = 0; i < this.product.categories_id.length; i++)
                {
                    this.$refs.tree.checkNode(this.product.categories_id[i]);
                    this.$refs.tree.expandNode(this.product.categories_id[i]);
                }

                if (!product.status_origami || product.status_origami == "enabled")
                    product.status_origami = "";
                
            },
            async send_list()
            {
				var str = json2csv(this.products_list, {
					fields: Object.keys(this.products_list[0]),
					fieldNames: Object.keys(this.products_list[0]),
					del: ",",
					quote: '"',
				});

				const bytes = new TextEncoder().encode(str);
				const blob = new Blob([bytes], {
					type: "text/plain",
				});

				await treatments
					.create(
						this.config.project,
						null,
						blob,
						"data.csv"
					).catch((err) => {
                    console.log("error : " + err);
                    this.$notify({
                        group: "info",
                        title: err.response.data.msg,
                        type: "error",
                    });
                });

                var ids = [];
                for (var i = 0; i < this.products_list.length; i++)
                {
                    ids.push(this.products_list[i].id);
                }

                for (var i = 0; i < this.products.length; i++)
                {
                    if (ids.includes(this.products[i].value))
                    {
                        this.products.splice(i, 1);
                        i--;
                    }
                }

                this.facet = "media"

                if (this.products.length > 0)
				{
                    await this.set_list();
                    this.mode = "list";
                    
                    window.scrollTo(0,0);
				}
				else
				{
                    this.products_list = []
                    this.products = null;
                    this.product = null;
				}
            },
            async send(wait)
			{
                this.product.categories_id = this.$refs.tree.getCheckedNodes("id", false);

				var str = json2csv([this.product], {
					fields: Object.keys(this.product),
					fieldNames: Object.keys(this.product),
					del: ",",
					quote: '"',
				});
				
				const bytes = new TextEncoder().encode(str);
				const blob = new Blob([bytes], {
					type: "text/plain",
				});

				await treatments
					.create(
						wait ? this.config.project : this.config.project_validation_hide,
						null,
						blob,
						"data.csv"
					).catch((err) => {
                    console.log("error : " + err);
                    this.$notify({
                        group: "info",
                        title: err.response.data.msg,
                        type: "error",
                    });
                });

                var index = -1;
                for (var i = 0; i < this.products.length; i++)
                {
                    if (this.product.id == this.products[i].value)
                    {
                        index = i;
                        break;
                    }
                }
                for (var i = 0; i < this.products_list.length; i++)
                {
                    if (this.product.id == this.products_list[i].id)
                    {
                        this.products_list.splice(i, 1);
                        break;
                    }
                }

				if (index !== -1) {
					this.products.splice(index, 1);
				}
				if (this.products.length > 0)
				{
                    if (index >= 0 && this.products.length - 1 >= index)
                    {
                        this.product_id = this.products[index].value;
                        await this.set();
                    }
                    else
                    {
                        await this.set_list();
                        this.mode = "list";
                    }
                    
                    window.scrollTo(0,0);
				}
				else
				{
                    this.products = null;
                    this.product = null;
				}
            },
            async f_search()
            {
                var where = "status = 'en cours' ";

                if (this.search.source)
                    where += 'and source = "' + this.search.source.replace(/"/, '\"') + '" ';
                if (this.search.brand)
                    where += 'and marque = "' + this.search.brand.replace(/"/, '\"') + '" ';
                if (this.search.name)
                    where += 'and nom_en like "%' + this.search.name.replace(/"/, '\"') + '%" ';
                if (this.search.category && this.categories_obj_names[this.search.category])
                    where += 'and REGEXP_LIKE(categories_id, ".*[^0-9]' + this.categories_obj_names[this.search.category].id + '[^0-9].*") ';

                if (this.rules_sql)
                    where += "and " + this.rules_sql + " ";

                where += "order by date, id";

                var products = await database.get("select", this.config.table, {
                    select: "id, categories_id, nom_en, nom_fr, nom_es, source, marque",
                    where: where
                });

                this.products = [];
                for (var i = 0; i < products.length; i++)
                {
                    this.products.push({value: products[i].id, text: (i + 1) + "/" + products.length + " - " + products[i].source + " - " + (products[i].nom_en || products[i].nom_fr || products[i].nom_es)});
                }

                if (this.products.length > 0)
                {
                    this.product_id = null;
                    this.mode = "list";
                    this.page = 0;
                    this.set_list();
                }
                else
                {
                    this.products_list = []
                    this.product_id = null;
                    this.product = null
                }
            },
            reset_search()
            {
                this.search = {
                    source: "",
                    brand: "",
                    category: "",
                    name: ""
                };
                $("#builder" + this.id).queryBuilder("reset");
            }
		},
		mounted: async function () {

            var self = this;

			let response = await users.getSelf(true);
			let client = response.client;

            if (!(client.details && client.details.pages && client.details.pages.green_musicians && client.details.pages.green_musicians.active))
            {
                this.$router.push({ name: "profile" });
			}

            this.config = client.details.pages.green_musicians;
            
            var categories = await database.get("select", this.config.table_categories, {
				select: "*",
				where: "level is not null order by level"
            });
            
            var categories_obj = {};

            //console.log(categories)

            for (var i = 0; i < categories.length; i++)
            {
                this.categories_obj[categories[i].id] = categories[i];
                this.categories_obj_names[categories[i].name_fr] = categories[i];
                if (categories[i].level == 0)
                {
                    var nodes = [];
                    this.categories.push({
                        id: categories[i].id,
                        parent: null,
                        text: categories[i].name_fr || categories[i].name || categories[i].es,
                        checkable: true,
                        selectable: false,
                        expandable: true,
                        state: {
                            checked: true,
                            expanded: true,
                            selected: false
                        },
                        nodes: nodes
                    })
                    categories_obj[categories[i].id] = nodes;
                }
                else if (categories[i].level > 0 && categories[i].parent_id && categories_obj[categories[i].parent_id])
                {
                    var nodes = [];
                    categories_obj[categories[i].parent_id].push({
                        id: categories[i].id,
                        parent: categories[i].parent_id,
                        text: categories[i].name_fr || categories[i].name || categories[i].es,
                        checkable: true,
                        selectable: false,
                        expandable: true,
                        state: {
                            checked: false,
                            expanded: false,
                            selected: false
                        },
                        nodes: nodes
                    })
                    categories_obj[categories[i].id] = nodes;
                }
            }

			var products = await database.get("select", this.config.table, {
				select: "id, categories_id, nom_en, nom_fr, nom_es, source, marque",
				where: "status = 'en cours' order by date, id"
			});

			for (var i = 0; i < products.length; i++)
			{
                this.products.push({value: products[i].id, text: (i + 1) + "/" + products.length + " - " + products[i].source + " - " + (products[i].nom_en || products[i].nom_fr || products[i].nom_es)});
                if (!this.sources.includes(products[i].source))
                    this.sources.push(products[i].source);
                if (!this.brands.includes(products[i].marque))
                    this.brands.push(products[i].marque);
                products[i].categories_id = JSON.parse(products[i].categories_id);
                for (var j = 0; j < products[i].categories_id.length; j++)
                {
                    if (this.categories_obj[products[i].categories_id[j]])
                    {
                        if (!this.categories_name.includes(this.categories_obj[products[i].categories_id[j]].name_fr))
                            this.categories_name.push(this.categories_obj[products[i].categories_id[j]].name_fr);
                    }
                }    
            }
            
            this.sources.sort();
            this.brands.sort();
            this.categories_name.sort();

            //console.log(this.categories)

			if (this.products.length > 0)
			{
                self.set_list();
            }

            var id = this.id;

            var columns = [
                { id: "`source`", label: "Source", type: "string" },
                { id: "`nom_en`", label: "Nom en", type: "string" },
                { id: "`nom_fr`", label: "Nom fr", type: "string" },
                { id: "`nom_es`", label: "Nom es", type: "string" },
                { id: "`description_courte_en`", label: "Description courte en", type: "string" },
                { id: "`description_courte_fr`", label: "Description courte fr", type: "string" },
                { id: "`description_courte_es`", label: "Description courte es", type: "string" },
                { id: "`description_en`", label: "Description en", type: "string" },
                { id: "`description_fr`", label: "Description fr", type: "string" },
                { id: "`description_es`", label: "Description es", type: "string" },
                { id: "`caracteristiques`", label: "Caractéristique", type: "string" },
                { id: "`marque`", label: "Marque", type: "string" },
                { id: "`url_image_reference`", label: "Url de l'image de référence", type: "string" },
                { id: "`urls_image`", label: "Images retenues", type: "string" },
                { id: "`list_urls_image`", label: "Autres images", type: "string" },
                { id: "`urls_youtube`", label: "Vidéos Youtube retenues", type: "string" },
                { id: "`list_urls_youtube`", label: "Autres vidéos Youtube", type: "string" },
                { id: "`prix_reference`", label: "Prix de référence, avec devise", type: "string" },
                { id: "`prix_achat`", label: "Prix d'achat", type: "double" },
                { id: "`prix`", label: "Prix en euros", type: "double" },
                { id: "`annonce`", label: "Création d'une annonce (0 : non, 1 : oui)", type: "boolean" },
                { id: "`date`", label: "Date de création de la fiche de validation", type: "datetime" }
            ]

            var config = {
                filters: columns,
                icons: {
                    add_group: "fas fa-plus-square",
                    add_rule: "fas fa-plus-circle",
                    remove_group: "fas fa-minus-square",
                    remove_rule: "fas fa-minus-circle",
                    error: "fas fa-exclamation-triangle",
                },
                operators: [
                    { type: "equal" },
                    { type: "not_equal" },
                    { type: "less" },
                    { type: "less_or_equal" },
                    { type: "greater" },
                    { type: "greater_or_equal" },
                    { type: "between" },
                    { type: "contains" },
                    { type: "not_contains" },
                    { type: "begins_with" },
                    { type: "ends_with" },
                    {
                        type: "is_empty",
                        apply_to: [
                            "string",
                            "number",
                            "datetime",
                            "boolean",
                        ],
                    },
                    {
                        type: "is_not_empty",
                        apply_to: [
                            "string",
                            "number",
                            "datetime",
                            "boolean",
                        ],
                    },
                ],
            };

            $("#builder" + id).queryBuilder(config);

            $("#builder" + id).on(
                "change",
                function (e, rule, error, value) {
                    try {
                        self.rules_sql = $("#builder" + id).queryBuilder(
                            "getSQL",
                            false
                        ).sql;
                        self.rules_sql = self.rules_sql;
                        self.rules_sql = self.rules_sql.replace(
                            /`([^`]*)` = ''/gi,
                            "(`$1` = '' or `$1` is NULL)"
                        );
                        self.rules_sql = self.rules_sql.replace(
                            /`([^`]*)` != ''/gi,
                            "(`$1` != '' and `$1` is not NULL)"
                        );
                        //console.log(self.rules_sql)
                        //self.updatePage();
                    } catch (err) {
                        self.rules_sql = "";
                    }
                }
            );

            $("#builder" + id).on(
                "afterDeleteRule.queryBuilder",
                function (e, rule, error, value) {
                    try {
                        //self.rules = $('#builder').queryBuilder('getRules');
                        self.rules_sql = $("#builder" + id).queryBuilder(
                            "getSQL",
                            false
                        ).sql;
                        //self.updatePage();
                    } catch (err) {
                        self.rules_sql = "";
                    }
                }
            );

            $("#builder" + id).on(
                "afterDeleteGroup.queryBuilder",
                function (e, group) {
                    try {
                        self.rules_sql = " " + $("#builder" + id).queryBuilder(
                            "getSQL",
                            false
                        ).sql;
                    } catch (err) {
                        self.rules_sql = "";
                    }
                }
            );
		},
	};
</script>

<style scoped>
	.center_spinner {
		width: 0%;
		margin: 0 auto;
        margin-bottom: 60px;
	}

    .long-tooltip .tooltip-inner
    {
        max-width: 600px !important;
        text-align: left !important;
    }
    .table-striped > tbody > tr:nth-child(2n+1) > td, .table-striped > tbody > tr:nth-child(2n+1) > th {
        background-color: WhiteSmoke;
    }

</style>